<template>
  <div class="ui right aligned container">
    <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
    <vuetable ref="vuetable"
              api-url="/hot"
              :fields="fields"
              :sort-order="sortOrder"
              :search="search"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <div class="ui grid">
      <div class="ui left aligned six wide column">
        <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      </div>
      <div class="right floated six wide column">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  import auth from '../services/Auth';
  import Vuetable from '../table/Vuetable.vue';
  import VuetablePagination from '../table/VuetablePagination.vue';
  import VuetablePaginationInfo from '../table/VuetablePaginationInfo.vue';

  export default {
    name: 'HotList',
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
    },
    mounted() {
      this.user = auth.user;
    },
    data() {
      return {
        search: '',
        after: '',
        user: {},
        fields: [
          {name: 'keywords', title: '关键词', callback: 'link', sortField: 'id'},
          {name: 'topRanking', title: '最高排名', sortField: 'topRanking'},
          {name: 'searchNums', title: '搜索量', callback: 'count', sortField: 'searchNums'},
          {name: 'views', title: '阅读量', callback: 'count2', sortField: 'views'},
          {name: 'comments', title: '讨论量', callback: 'count2', sortField: 'comments'},
          {name: 'duration', title: '累计在榜时间', callback: 'duration', sortField: 'duration'},
          {name: 'updateTime', title: '最近上榜时间', callback: 'date', sortField: 'id'},
          {name: 'type', title: '类型', callback: 'type', sortField: 'type'},
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ]
      };
    },
    methods: {
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.$refs.paginationInfo.setPaginationData(paginationData);
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      link: function (value, item) {
        if (item.url) {
          return '<a href="' + item.url + '" target="_blank">' + value + '</a>';
        } else {
          return value;
        }
      },
      type: function (value, item) {
        if (value === 'douyin') {
          return '抖音';
        } else if (value === 'toutiao' || value === 'toutiao-hotsearch') {
          return '<a href="' + item.url + '" target="_blank">头条</a>';
        } else {
          return '<a href="' + item.url + '" target="_blank">微博</a>';
        }
      },
      count: function (value) {
        if (value > 0) {
          return value;
        } else {
          return '-';
        }
      },
      count2: function (num) {
        if (num > 0) {
          if (num >= 100000000) {
            return (num / 100000000).toFixed(1) + '亿';
          } else if (num >= 10000) {
            return (num / 10000).toFixed(1) + '万';
          } else {
            return num;
          }
        } else {
          return '-';
        }
      },
      date: function (value) {
        let date = new Date(value);
        return date.toLocaleString();
      },
      duration: function (value) {
        let h = Math.floor(value / 3600);
        let m = Math.floor((value - h * 3600) / 60);
        return (h ? h + '小时' : '') + (m ? m + '分' : '');
      },
      refresh: function () {
        this.$refs.vuetable.reload();
      },
    }
  };
</script>
